import { useCallback, useEffect, useState } from 'react';

export type ThemeMode = 'ambient' | 'showcase';

const STORAGE_KEY = 'ryven-wiki-mode';

function readStored(): ThemeMode {
  if (typeof window === 'undefined') return 'ambient';
  return window.localStorage.getItem(STORAGE_KEY) === 'showcase' ? 'showcase' : 'ambient';
}

export function useThemeMode(): [ThemeMode, (m: ThemeMode) => void] {
  const [mode, setModeState] = useState<ThemeMode>(readStored);

  useEffect(() => {
    document.documentElement.classList.toggle('showcase', mode === 'showcase');
  }, [mode]);

  const setMode = useCallback((m: ThemeMode) => {
    setModeState(m);
    try {
      window.localStorage.setItem(STORAGE_KEY, m);
    } catch {
      // localStorage unavailable — in-memory only
    }
  }, []);

  return [mode, setMode];
}
